import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        Kirsten is a chump
      </header>
    </div>
  );
}

export default App;
